import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { formatDateLocalTZ } from "utils/utils";
import { HEADER_STRINGS } from "constants/constantStrings";
import SYSTEM_STATUS from "constants/systemStatus";

import TooltipLabelWithEllipsis from "components/TooltipLabelWithEllipsis";

import UpdateIcon from "assets/Header/update.svg";
import AlarmingIcon from "assets/SvgIcon/StatusIcon/alarming";
import IdleIcon from "assets/SvgIcon/StatusIcon/idle";
import OfflineIcon from "assets/SvgIcon/StatusIcon/offline";
import RunningIcon from "assets/SvgIcon/StatusIcon/running";

import "./index.scss";

const StatusIndicator = ({ name, systemID, lastActiveTime }) => {
  const systemsAsObj = useSelector(state => state.systems.systemsAsObj);
  const [systemData, setSystemData] = useState(null);
  const [systemLastUpdatedTime, setSystemLastUpdatedTime] = useState(lastActiveTime);

  useEffect(() => setSystemData(getSystem()), [systemID]);
  useEffect(() => setSystemLastUpdatedTime(lastActiveTime), [lastActiveTime]);

  const getSystem = () => {
    let systemData;
    if (systemsAsObj && systemID) {
      systemData = systemsAsObj[systemID];
    }
    return systemData;
  };

  const systemStatusIndicator = {
    [SYSTEM_STATUS.STATUS_STOPPED]: <IdleIcon name={name} />,
    [SYSTEM_STATUS.STATUS_RUNNING]: <RunningIcon name={name} />,
    [SYSTEM_STATUS.STATUS_ALARM]: <AlarmingIcon name={name} />,
    [SYSTEM_STATUS.STATUS_DISCONNECTED]: <OfflineIcon name={name} />
  };

  const getSystemStatus = () => {
    try {
      if (systemsAsObj) {
        const sysData = systemsAsObj[systemID];
        const { systemStatus, connectionStatus } = sysData;
        if (connectionStatus === SYSTEM_STATUS.STATUS_ONLINE) {
          return systemStatusIndicator[systemStatus];
        } else {
          return <OfflineIcon name={name} />;
        }
      }
    } catch (error) {
      return <OfflineIcon name={name} />;
    }
  };

  const isShowLastUpdatedTime = () => {
    let isOffline = false;
    if (systemLastUpdatedTime) {
      const sysData = getSystem();
      if (sysData) {
        const { systemStatus, connectionStatus } = sysData;
        const { STATUS_STOPPED, STATUS_OFFLINE } = SYSTEM_STATUS;
        isOffline = connectionStatus === STATUS_STOPPED || systemStatus === STATUS_OFFLINE;
      }
    }
    return isOffline;
  };

  return (
    <div className="header__system--status">
      {systemData && (
        <div className="headerSystemStatus">
          <div className="statusIndicator statusIndicator-iconWrapper">{getSystemStatus()}</div>
          {name && (
            <span className="onlineStatus">
              <TooltipLabelWithEllipsis
                label={systemData.systemName}
                customClass="sysNameHeader overflow ellipsis"
                multiline={false}
              />
            </span>
          )}
        </div>
      )}
      {isShowLastUpdatedTime() && (
        <div className="descriptionWhiteText last-updated--message">
          <img src={UpdateIcon} alt="update" /> {HEADER_STRINGS.lastUpdate}
          {formatDateLocalTZ(systemLastUpdatedTime)}
        </div>
      )}
    </div>
  );
};

export default StatusIndicator;
